import { render, staticRenderFns } from "./GlossaryDetail.vue?vue&type=template&id=72e1c1a6&scoped=true&"
import script from "./GlossaryDetail.vue?vue&type=script&lang=js&"
export * from "./GlossaryDetail.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryDetail.vue?vue&type=style&index=0&id=72e1c1a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e1c1a6",
  null
  
)

export default component.exports